@font-face {
  font-family: "ionicons";
  src: url("/fonts/Ionicons.b4eb097d35f44ed943676fd56f6bdc51.ttf") format("truetype");
  font-style: normal;
  font-weight: 400;
  font-display: block;
}

.opncue-progress-export-host {
  width: 1px;
  height: 1px;
  overflow: hidden;
  pointer-events: none;
}

.opncue-progress-export-frame {
  width: 1080px;
  height: 1920px;
  background: #f4faff;
}

.opncue-progress-poster {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 1080px;
  height: 1920px;
  overflow: hidden;
  justify-content: center;
  padding: 71px 96px;
  background: linear-gradient(135deg, var(--poster-bg-start), var(--poster-bg-end));
  color: var(--poster-text);
}

.opncue-progress-poster *,
.opncue-progress-poster *::before,
.opncue-progress-poster *::after {
  box-sizing: border-box;
}

.opncue-progress-poster--classic {
  --poster-accent: #0b7dff;
  --poster-accent-dark: #071f4d;
  --poster-halo: #eaf4ff;
  --poster-card: #ffffff;
  --poster-bg-start: #f4faff;
  --poster-bg-end: #e1f0ff;
  --poster-text: #061a44;
  --poster-muted: #6e7d98;
}

.opncue-progress-poster--sky {
  --poster-accent: #1d9bf0;
  --poster-accent-dark: #082f5f;
  --poster-halo: #e7f6ff;
  --poster-card: #ffffff;
  --poster-bg-start: #f7fcff;
  --poster-bg-end: #d8ecff;
  --poster-text: #062b55;
  --poster-muted: #667a96;
}

.opncue-progress-poster--mint {
  --poster-accent: #059b8e;
  --poster-accent-dark: #063f3b;
  --poster-halo: #e7faf6;
  --poster-card: #ffffff;
  --poster-bg-start: #f6fffc;
  --poster-bg-end: #ddf6ef;
  --poster-text: #083e3a;
  --poster-muted: #647a76;
}

.opncue-progress-poster--pink {
  --poster-accent: #ec4899;
  --poster-accent-dark: #831843;
  --poster-halo: #fce7f3;
  --poster-card: #ffffff;
  --poster-bg-start: #fff7fb;
  --poster-bg-end: #fce7f3;
  --poster-text: #3b1028;
  --poster-muted: #8a6a78;
}

.opncue-progress-poster--ink {
  --poster-accent: #7db7ff;
  --poster-accent-dark: #f7fbff;
  --poster-halo: #15243d;
  --poster-card: #071529;
  --poster-bg-start: #0d1b2e;
  --poster-bg-end: #132a46;
  --poster-text: #f7fbff;
  --poster-muted: #aab8cd;
}

.opncue-progress-poster--custom-amber {
  --poster-accent: #d97706;
  --poster-accent-dark: #63370a;
  --poster-halo: #fef3c7;
  --poster-card: #ffffff;
  --poster-bg-start: #fffdf5;
  --poster-bg-end: #fef3c7;
  --poster-text: #3e2508;
  --poster-muted: #806f55;
}

.opncue-progress-poster--custom-violet {
  --poster-accent: #8b5cf6;
  --poster-accent-dark: #3b176d;
  --poster-halo: #ede9fe;
  --poster-card: #ffffff;
  --poster-bg-start: #fbfaff;
  --poster-bg-end: #ede9fe;
  --poster-text: #29124d;
  --poster-muted: #74688e;
}

.opncue-progress-poster--custom-coral {
  --poster-accent: #f97316;
  --poster-accent-dark: #7c2d12;
  --poster-halo: #ffedd5;
  --poster-card: #ffffff;
  --poster-bg-start: #fff8f1;
  --poster-bg-end: #ffedd5;
  --poster-text: #44200d;
  --poster-muted: #846d5c;
}

.opncue-progress-poster--custom-ruby {
  --poster-accent: #dc2626;
  --poster-accent-dark: #7f1d1d;
  --poster-halo: #fee2e2;
  --poster-card: #ffffff;
  --poster-bg-start: #fff7f7;
  --poster-bg-end: #fee2e2;
  --poster-text: #3d1010;
  --poster-muted: #856a6a;
}

.opncue-progress-poster--custom-indigo {
  --poster-accent: #4f46e5;
  --poster-accent-dark: #312e81;
  --poster-halo: #e0e7ff;
  --poster-card: #ffffff;
  --poster-bg-start: #f8faff;
  --poster-bg-end: #e0e7ff;
  --poster-text: #1e1b4b;
  --poster-muted: #6a6f8f;
}

.opncue-progress-poster--custom-lime {
  --poster-accent: #65a30d;
  --poster-accent-dark: #365314;
  --poster-halo: #ecfccb;
  --poster-card: #ffffff;
  --poster-bg-start: #fbfff4;
  --poster-bg-end: #ecfccb;
  --poster-text: #25330d;
  --poster-muted: #687755;
}

.opncue-progress-poster--custom-graphite {
  --poster-accent: #64748b;
  --poster-accent-dark: #1e293b;
  --poster-halo: #e2e8f0;
  --poster-card: #ffffff;
  --poster-bg-start: #f8fafc;
  --poster-bg-end: #e2e8f0;
  --poster-text: #172033;
  --poster-muted: #687385;
}

.opncue-progress-poster__shape {
  position: absolute;
  opacity: 0.62;
  background: var(--poster-halo);
}

.opncue-progress-poster__shape--top {
  top: -210px;
  right: -220px;
  width: 680px;
  height: 480px;
  border-bottom-left-radius: 480px;
}

.opncue-progress-poster__shape--bottom {
  right: -225px;
  bottom: -150px;
  width: 610px;
  height: 420px;
  border-top-left-radius: 420px;
}

.opncue-progress-poster__card {
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 59px 88px 46px;
  border: 2px solid var(--poster-halo);
  border-radius: 74px;
  background: var(--poster-card);
}

.opncue-progress-poster__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 17px;
}

.opncue-progress-poster__heart {
  display: block;
  width: 54px;
  height: 54px;
  color: var(--poster-accent);
  font-family: "ionicons";
  font-size: 54px;
  font-weight: 400;
  line-height: 54px;
  text-align: center;
}

.opncue-progress-poster__kicker,
.opncue-progress-poster__brand,
.opncue-progress-poster__date,
.opncue-progress-poster__main-value,
.opncue-progress-poster__secondary-value,
.opncue-progress-poster__safe-stats {
  font-family: var(--font-display);
}

.opncue-progress-poster__headline,
.opncue-progress-poster__label,
.opncue-progress-poster__secondary-label,
.opncue-progress-poster__tagline {
  font-family: var(--font-serif);
}

.opncue-progress-poster__kicker {
  color: var(--poster-accent);
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 12px;
  line-height: 36px;
  text-align: center;
  text-transform: uppercase;
}

.opncue-progress-poster__brand {
  color: var(--poster-accent);
  font-size: 86px;
  font-weight: 800;
  line-height: 96px;
}

.opncue-progress-poster__date {
  color: var(--poster-muted);
  font-size: 30px;
  font-weight: 800;
  line-height: 38px;
}

.opncue-progress-poster__headline {
  max-width: 100%;
  color: var(--poster-text);
  font-size: 67px;
  font-weight: 800;
  line-height: 78px;
  text-align: center;
}

.opncue-progress-poster__main {
  position: relative;
  display: flex;
  width: 410px;
  height: 410px;
  align-items: center;
  justify-content: center;
}

.opncue-progress-poster__main-halo {
  position: absolute;
  width: 410px;
  height: 410px;
  border-radius: 205px;
  background: var(--poster-halo);
  opacity: 0.92;
}

.opncue-progress-poster__main-value {
  position: relative;
  width: 320px;
  color: var(--poster-accent);
  font-weight: 800;
  line-height: 1.13;
  text-align: center;
  white-space: nowrap;
}

.opncue-progress-poster__main-value--fit-1 {
  font-size: 250px;
}

.opncue-progress-poster__main-value--fit-4 {
  font-size: 188px;
}

.opncue-progress-poster__main-value--fit-5 {
  font-size: 150px;
}

.opncue-progress-poster__main-value--fit-long {
  font-size: 125px;
}

.opncue-progress-poster__label {
  max-width: 100%;
  color: var(--poster-text);
  font-weight: 800;
  line-height: 1.15;
  text-align: center;
}

.opncue-progress-poster__label--fit-1 {
  font-size: 54px;
}

.opncue-progress-poster__label--fit-2 {
  font-size: 45px;
}

.opncue-progress-poster__label--fit-3 {
  font-size: 36px;
}

.opncue-progress-poster__label--fit-4 {
  font-size: 27px;
}

.opncue-progress-poster__secondary-row {
  display: flex;
  width: 100%;
  min-height: 220px;
  align-items: stretch;
  justify-content: center;
  gap: 32px;
}

.opncue-progress-poster__secondary-wrap {
  display: flex;
  align-items: stretch;
  gap: 32px;
}

.opncue-progress-poster__secondary-spacer {
  min-height: 220px;
}

.opncue-progress-poster__secondary-divider {
  width: 3px;
  height: 150px;
  align-self: center;
  background: var(--poster-accent);
  opacity: 0.35;
}

.opncue-progress-poster__secondary-tile {
  display: flex;
  width: 316px;
  min-height: 212px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 30px;
  border-radius: 42px;
  background: var(--poster-halo);
}

.opncue-progress-poster__stat-icon {
  display: block;
  width: 60px;
  height: 60px;
  color: var(--poster-accent);
  font-family: "ionicons";
  font-size: 60px;
  font-weight: 400;
  line-height: 60px;
  text-align: center;
}

.opncue-progress-poster__secondary-value {
  width: 210px;
  color: var(--poster-accent);
  font-weight: 800;
  line-height: 1.13;
  text-align: center;
  white-space: nowrap;
}

.opncue-progress-poster__secondary-value--fit-1 {
  font-size: 78px;
}

.opncue-progress-poster__secondary-value--fit-2 {
  font-size: 52px;
}

.opncue-progress-poster__secondary-value--fit-long {
  font-size: 39px;
}

.opncue-progress-poster__secondary-label {
  color: var(--poster-text);
  font-weight: 800;
  line-height: 1.24;
  text-align: center;
}

.opncue-progress-poster__secondary-label--fit-1 {
  font-size: 34px;
}

.opncue-progress-poster__secondary-label--fit-2 {
  font-size: 28px;
}

.opncue-progress-poster__secondary-label--fit-3 {
  font-size: 22px;
}

.opncue-progress-poster__secondary-label--fit-4 {
  font-size: 17px;
}

.opncue-progress-poster__footer {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.opncue-progress-poster__rule {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 34px;
  margin-bottom: 31px;
}

.opncue-progress-poster__rule-line {
  flex: 1;
  height: 2px;
  background: var(--poster-accent);
  opacity: 0.3;
}

.opncue-progress-poster__sparkle {
  display: block;
  width: 42px;
  height: 42px;
  color: var(--poster-accent);
  font-family: "ionicons";
  font-size: 42px;
  font-weight: 400;
  line-height: 42px;
  text-align: center;
}

.opncue-progress-poster__tagline {
  color: var(--poster-accent);
  font-size: 46px;
  font-weight: 800;
  line-height: 56px;
  text-align: center;
}

.opncue-progress-poster__tagline strong {
  color: var(--poster-accent-dark);
}

.opncue-progress-poster__safe-stats {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 38px;
  color: var(--poster-muted);
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
}

.opncue-progress-poster__lock {
  display: block;
  width: 25px;
  height: 25px;
  font-family: "ionicons";
  font-size: 25px;
  font-weight: 400;
  line-height: 25px;
  text-align: center;
}
